<style scoped>

</style>
<template>
  <MenuGroup
    v-if="optionsItem.items&&!optionsItem.path"
    :title="optionsItem.name"
  >
    <RouterSelectOptions
      v-for="item in optionsItem.items"
      v-show="showHash[optionsItem.id]"
      :key="item.id"
      :show-hash="showHash"
      :options-item="item"
    />
  </MenuGroup>
  <MenuItem
    v-else
    v-show="showHash[optionsItem.id]"
    :name="optionsItem.id"
  >
    {{ optionsItem.name }}
  </MenuItem>
</template>
<script>
    export default {
        name: 'RouterSelectOptions',
        props: {
           optionsItem:{
               type: Object,
               default: () => ({})
           },
           showHash: {
               type: Object,
               default: () => ({})
           }
        },
    }
</script>
